export const resolveCompanyPeopleStory = (scroll: number, viewport: number, steps: number) => {
  const height = Math.max(1, viewport);
  const count = Math.max(1, steps);
  const offset = Math.max(0, Math.min(Number.isFinite(scroll) ? scroll : 0, (count - 1) * height));
  const position = offset / height;
  const activeStep = Math.min(count - 1, Math.floor(position + 0.5));
  return { offset, position, activeStep, open: Math.min(1, position), contactActive: position >= count - 1 - 0.025 };
};
